/* eslint-disable */
/**
 * @fileoverview Recent Activity Component
 *
 * Displays a feed of recent activities.
 * Currently prepared for future use - the dashboard shows bookmarked clients instead.
 *
 * @author Clockwise CPA Development Team
 * @version 1.0.0
 */

import React, { memo } from 'react';
import { FiActivity, FiRefreshCw, FiFileText } from 'react-icons/fi';
import { useUtils } from '../../../context/UtilContext';

/**
 * RecentActivity Component
 *
 * @param {Object} props
 * @param {Array} props.activities - List of activities
 * @param {boolean} props.loading - Loading state
 * @param {Function} props.onRefresh - Refresh callback
 * @returns {JSX.Element}
 */
const RecentActivity = memo(({ activities, loading, onRefresh }) => {
    const { formatDate } = useUtils();

    return (
        <section className="dashboard-activities">
            <div className="d-section-header">
                <h2 className="section-title">
                    <FiActivity className="section-icon" /> Recent Activity
                </h2>
                <button
                    className="d-refresh-button"
                    onClick={onRefresh}
                    disabled={loading}
                >
                    {loading ? (
                        <FiRefreshCw className="spinner" />
                    ) : (
                        <FiRefreshCw />
                    )}
                </button>
            </div>
            <div className="activity-list">
                {activities?.length > 0 ? (
                    <ul className="activity-timeline">
                        {activities.map((activity, index) => (
                            <li key={activity.id || index} className="activity-item-d">
                                <div className="activity-dot"></div>
                                <div className="activity-content">
                                    <p>{activity.description || activity.action}</p>
                                    <span className="activity-time">
                                        {formatDate ? formatDate(activity.created_at) : new Date(activity.created_at).toLocaleString()}
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className="empty-state">
                        <FiFileText className="empty-icon" />
                        <p>No recent activity</p>
                        <span>Activity will appear here as you work</span>
                    </div>
                )}
            </div>
        </section>
    );
});

RecentActivity.displayName = 'RecentActivity';

export default RecentActivity;
